export default __webpack_public_path__ + "static/media/feedbackDesktop.8bc31c36.jpg";